import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import { PasswordConfigServices } from '@/services/PasswordConfigServices';

import { TAppError } from '@/store/types/base.state';
import {
  IPasswordStrategy,
  TPasswordStrategyAction,
  PasswordConfigActionTypes,
  IPasswordStrategyState,
} from '@/store/types/password-config.types';
import { TCoreAction } from '@/store/types/modals.types';

import { closeModal } from '@/store/actions/core.actions';

export const getPasswordStrategy = (): ThunkAction<
  Promise<void>,
  IPasswordStrategyState,
  {},
  TPasswordStrategyAction
> => {
  const request = (): TPasswordStrategyAction => ({
    type: PasswordConfigActionTypes.GET_PASSWORD_STRATEGY,
    shouldSkipToaster: true,
  });
  const fail = (error: TAppError): TPasswordStrategyAction => ({
    type: PasswordConfigActionTypes.GET_PASSWORD_STRATEGY_FAIL,
    error,
    documentation: 'https://docs.treezor.com/guide/dashboard/configuration.html#define-a-password-policy',
  });
  const success = (passwordStrategy: IPasswordStrategy): TPasswordStrategyAction => ({
    type: PasswordConfigActionTypes.GET_PASSWORD_STRATEGY_SUCCESS,
    passwordStrategy,
    shouldSkipToaster: true,
  });

  return async (dispatch: ThunkDispatch<IPasswordStrategyState, {}, TPasswordStrategyAction>): Promise<void> => {
    dispatch(request());
    try {
      const passwordStrategy = await PasswordConfigServices.getPasswordPatternStrategy();
      dispatch(success(passwordStrategy));
    } catch (error) {
      dispatch(fail(error));
    }
  };
};

export const setPasswordStrategy = (
  data: IPasswordStrategy,
): ThunkAction<Promise<void>, IPasswordStrategyState, {}, TPasswordStrategyAction | TCoreAction> => {
  const request = (): TPasswordStrategyAction => ({
    type: PasswordConfigActionTypes.SET_PASSWORD_STRATEGY,
    shouldSkipToaster: true,
  });
  const fail = (error: TAppError): TPasswordStrategyAction => ({
    type: PasswordConfigActionTypes.SET_PASSWORD_STRATEGY_FAIL,
    error,
    documentation: 'https://docs.treezor.com/guide/dashboard/configuration.html#define-a-password-policy',
  });
  const success = (passwordStrategy: IPasswordStrategy): TPasswordStrategyAction => ({
    type: PasswordConfigActionTypes.SET_PASSWORD_STRATEGY_SUCCESS,
    passwordStrategy,
  });

  return async (
    dispatch: ThunkDispatch<IPasswordStrategyState, {}, TPasswordStrategyAction | TCoreAction>,
  ): Promise<void> => {
    dispatch(request());
    try {
      const passwordStrategy = await PasswordConfigServices.setPasswordPatternStrategy(data);
      dispatch(success(passwordStrategy));
      dispatch(closeModal());
    } catch (error) {
      dispatch(fail(error));
    }
  };
};
